import { useContainer, usePlayer } from "../../player/context.js";
import { createDoubleTapGesture, createTapGesture, getGestureActionValue, resolveGestureAction } from "@videojs/core/dom";
import { useEffect } from "react";
//#region src/ui/gesture/component.tsx
function Gesture({ type, action, value, pointer, region, disabled }) {
	const store = usePlayer();
	const container = useContainer();
	useEffect(() => {
		if (!container || !type || !action || disabled) return;
		const resolver = resolveGestureAction(action);
		if (!resolver) return;
		const actionValue = getGestureActionValue(action, region, value);
		const onActivate = (event) => {
			resolver({
				store,
				value: actionValue,
				event
			});
		};
		const options = {
			pointer,
			region,
			action,
			value: actionValue
		};
		if (type === "doubletap") return createDoubleTapGesture(container, onActivate, options);
		if (type === "tap") return createTapGesture(container, onActivate, options);
	}, [
		container,
		store,
		type,
		action,
		value,
		pointer,
		region,
		disabled
	]);
	return null;
}
/** @deprecated Use `Gesture` instead. */
const MediaGesture = Gesture;
//#endregion
export { Gesture, MediaGesture };

//# sourceMappingURL=component.js.map